module.exports = __webpack_public_path__ + "tables/media/Documentation_filled.d8f52218.svg";